export const getPHTDate = (dateParam) => {
  if (!dateParam) {
    const d = new Date();
    const rawPHT = d.toLocaleString("en-US", { timeZone: "Asia/Manila" });
    return new Date(rawPHT);
  }

  if (typeof dateParam === 'string') {
    let sanitized = dateParam.replace(' ', 'T');
    const d = new Date(sanitized);
    if (isNaN(d.getTime())) return d;
    const rawPHT = d.toLocaleString("en-US", { timeZone: "Asia/Manila" });
    return new Date(rawPHT);
  }

  const d = new Date(dateParam);
  return d;
};

export const formatDateTime = (dateString) => {
  if (!dateString) return "";
  const d = getPHTDate(dateString);

  const month = d.toLocaleString('en-US', { month: 'short' });
  const day = String(d.getDate()).padStart(2, '0');
  const year = d.getFullYear();
  const hour = String(d.getHours()).padStart(2, '0');
  const minute = String(d.getMinutes()).padStart(2, '0');

  return `${month} ${day}, ${year}, ${hour}:${minute}`;
};

export const formatPHDatetime = (dateString) => {
  if (!dateString) return "";
  const d = getPHTDate(dateString);
  if (isNaN(d.getTime())) return "Invalid Date";

  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const month = months[d.getMonth()];
  const day = String(d.getDate()).padStart(2, '0');
  const year = d.getFullYear();
  const hour = String(d.getHours()).padStart(2, '0');
  const minute = String(d.getMinutes()).padStart(2, '0');

  return `${month} ${day}, ${year}, ${hour}:${minute}`;
};
